module.exports = __webpack_public_path__ + "static/media/buy_shirt.d7b7401b.svg";